module.exports = __webpack_public_path__ + "static/media/CabinetCorner_Before.40a2a9c3.jpg";